import { GetStaticPropsContext, NextPageContext } from 'next'
import { Store } from 'redux'
import {
  institutionItemSelectors,
  institutionItemThunks,
} from '@ucheba/store/institutions/item'
import { articlesThunks } from '@ucheba/store/articles'
import { headerActions } from '../../../components/Header/store'

type GetInstitutionArticlesPageProps = {
  ctx: NextPageContext | GetStaticPropsContext
  store: Store
}

type GetInstitutionArticlesPageReturn = Promise<{
  notFound?: boolean
  content?: {
    seo: {
      meta: {
        title: string
        description: string
        keywords: string
      }
    }
  }
}>

export const getInstitutionArticlesPageProps = async (
  props: GetInstitutionArticlesPageProps
): GetInstitutionArticlesPageReturn => {
  const { ctx, store } = props
  const query = (ctx as GetStaticPropsContext).params || (ctx as NextPageContext).query
  const { dispatch, getState } = store
  const id = query?.id

  if (!getState()?.institutionItem?.currentInstitution?.id) {
    await dispatch<any>(institutionItemThunks.fetchInstitution({ ctx, data: { id } }))
  }

  const institution = institutionItemSelectors.currentInstitution(getState())

  if (!institution) {
    return {
      notFound: true,
    }
  }

  const { description, name, keywords, hasArticles } = institution

  if (hasArticles) {
    await dispatch<any>(
      articlesThunks.fetch({
        ctx,
        data: {
          institutionId: id,
          limit: 16,
          offset: Number(query.page) > 1 ? (Number(query.page) - 1) * 16 : 0,
        },
      })
    )
  }

  dispatch(headerActions.toggleHeader(true))

  return {
    content: {
      seo: {
        meta: {
          title: `${name} — Журнал — Учёба.ру`,
          description: description || '',
          keywords,
        },
      },
    },
  }
}
